module.exports = __webpack_public_path__ + "img/lock-pattern.3dd88443.svg";